import Button from "@mui/material/Button";
import React, { useContext, useEffect, useState } from "react";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import GenericDialog from "../GenericDialog";
import { HomeAppContext } from "../Home";
import Form, { DatasetFormMode } from "./DatasetForm";

const initialEntry = {
  name: "",
  description: "",
  variables: [],
  values: [],
  prompts: [],
  fileIds: [],
  dataMappings: []
};

export default function Create({ open, setOpen, onCreate }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const [internalEntry, setInternalEntry] = useState(initialEntry);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [variablesFromApi, setVariablesFromApi] = useState([]);

  useEffect(() => {
    if (open) {
      setInternalEntry(initialEntry);
      setSubmitted(false);
      setErrors([]);
      setLoading(false);
    } else {
      setVariablesFromApi([]);
    }
  }, [open]);

  const prepareDataForSubmission = () => {
    const fileIds = Array.isArray(internalEntry.fileIds) 
      ? internalEntry.fileIds.map(file => {
          if (typeof file === 'object' && file !== null) {
            return file.id || file.fileId || 0;
          }
          return typeof file === 'number' ? file : 0;
        }).filter(id => id > 0)
      : [];

    const values = Array.isArray(internalEntry.values)
      ? internalEntry.values.map(value => {
          if (typeof value === 'string') {
            return value.split('`');
          }
          return Array.isArray(value) ? value : [];
        })
      : [];

      const validMappings = (internalEntry.dataMappings || [])
      .filter(mapping => mapping.variableName && mapping.variableName.trim() !== '')
      .map(mapping => ({
        ...mapping,
        type: typeof mapping.type === 'number' ? mapping.type : parseInt(mapping.type, 10)
      }));

    return {
      name: internalEntry.name || "",
      description: internalEntry.description || "",
      fileIds: fileIds,
      variables: Array.isArray(internalEntry.variables) ? internalEntry.variables : [],
      values: values,
      dataMappings: validMappings.length > 0 ? validMappings : null
    };
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
    setInternalEntry(initialEntry);
  };

  const handleCloseSave = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Saving dataset", loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    
    const newDataset = prepareDataForSubmission();
    
    api
      .post(`/api/datasets`, newDataset)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: 'Saved dataset "' + response.data.name + '"',
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        setInternalEntry(initialEntry);
        onCreate();
      })
      .catch((error) => {
        setLoading(false);
        console.error("API Error:", error);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={handleCloseSave}
        color="primary"
        variant="outlined"
        autoFocus
        disabled={loading || saveDisabled}
      >
        Save Dataset
      </Button>
    </>
  );
  
  return (
    <GenericDialog
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      title={"New Dataset"}
      actions={actions}
    >
      <Form
        mode={DatasetFormMode.NEW}
        entity={internalEntry}
        open={open}
        variables={variablesFromApi}
        errors={errors}
        setEntity={setInternalEntry}
        loading={loading}
        submitted={submitted}
        setSaveDisabled={setSaveDisabled}
      />
    </GenericDialog>
  );
}
